import { DateUtils } from '@app/utils/date';
import { Value } from '@app/utils/filter/terms/value';

export function calculateDifference(value: any, bound: Value): number | null {
  let difference: number | null;

  if (bound.type === 'date') {
    difference = DateUtils.difference(bound.value, value, 'day');
  } else {
    difference = parseInt(value, 10) - bound.value;
  }

  return difference;
}
